const NANOOX_TIME_ZONE = "America/Santiago";
const EXPLICIT_TIME_ZONE_RE = /(Z|[+-]\d{2}:?\d{2})$/i;
const LOCAL_TIMESTAMP_RE =
  /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/;

function getDateAndTimeZone(value) {
  const text = String(value ?? "").trim();
  if (!text || text === "--") return null;

  // Los timestamps sin offset que entrega Nanoox ya representan la hora local
  // del centro. Se construyen en UTC solo para conservar sus componentes al
  // formatearlos, sin depender de la zona horaria del navegador.
  if (!EXPLICIT_TIME_ZONE_RE.test(text)) {
    const match = text.match(LOCAL_TIMESTAMP_RE);
    if (!match) return null;

    const [, year, month, day, hour, minute, second = "00"] = match;
    return {
      date: new Date(
        Date.UTC(
          Number(year),
          Number(month) - 1,
          Number(day),
          Number(hour),
          Number(minute),
          Number(second)
        )
      ),
      timeZone: "UTC",
    };
  }

  const date = new Date(text);
  if (Number.isNaN(date.getTime())) return null;
  return { date, timeZone: NANOOX_TIME_ZONE };
}

function formatWithFallback(date, locale, options) {
  try {
    return new Intl.DateTimeFormat(locale || "es-CL", options).format(date);
  } catch {
    return new Intl.DateTimeFormat("es-CL", options).format(date);
  }
}

export function formatNanooxTimestamp(value, locale = "es-CL") {
  const parsed = getDateAndTimeZone(value);
  if (!parsed) {
    const text = String(value ?? "").trim();
    return text && text !== "--" ? text.split("+")[0] : "--";
  }

  return formatWithFallback(parsed.date, locale, {
    timeZone: parsed.timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).replace(",", "");
}

export function getNanooxClockParts(value, locale = "es-CL") {
  const parsed = getDateAndTimeZone(value);
  if (!parsed) return { date: "", time: "" };

  return {
    date: formatWithFallback(parsed.date, locale, {
      timeZone: parsed.timeZone,
      weekday: "long",
      day: "numeric",
      month: "long",
    }),
    time: formatWithFallback(parsed.date, locale, {
      timeZone: parsed.timeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    }),
  };
}
